import React from 'react';
import { SurveyBlock, SurveyAnswers } from '../../types/survey';
import { RadioQuestion } from './RadioQuestion';
import { Card, CardContent, CardHeader } from '../ui/Card';
import { motion } from 'framer-motion';
interface QuestionBlockProps {
  block: SurveyBlock;
  answers: SurveyAnswers;
  onAnswer: (questionId: string, optionId: string) => void;
}
export function QuestionBlock({
  block,
  answers,
  onAnswer
}: QuestionBlockProps) {
  // Filter questions based on conditional logic
  const visibleQuestions = block.questions.filter(q => {
    if (!q.conditionalOn) return true;
    const {
      questionId,
      expectedValue
    } = q.conditionalOn;
    return answers[questionId] === expectedValue;
  });
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} exit={{
    opacity: 0,
    y: -20
  }} transition={{
    duration: 0.3
  }} data-id="element-30">
      <Card className="border-t-4 border-t-teal-600" data-id="element-31">
        <CardHeader data-id="element-32">
          <h2 className="text-xl font-bold text-slate-900" data-id="element-33">{block.title}</h2>
          <p className="text-slate-600 mt-1" data-id="element-34">{block.description}</p>
        </CardHeader>

        <CardContent className="space-y-8" data-id="element-35">
          {visibleQuestions.map(question => <RadioQuestion key={question.id} question={question} selectedOptionId={answers[question.id]} onSelect={onAnswer} data-id="element-36" />)}
        </CardContent>
      </Card>
    </motion.div>;
}